module.exports = __webpack_public_path__ + "static/img/step-02.ae73d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-02.png
// module id = c9H8
// module chunks = 1